import { render } from "./reportNumber.vue?vue&type=template&id=05b6ac21&scoped=true"
import script from "./reportNumber.vue?vue&type=script&lang=js"
export * from "./reportNumber.vue?vue&type=script&lang=js"

import "./reportNumber.vue?vue&type=style&index=0&id=05b6ac21&scoped=true&lang=css"
import "./reportNumber.vue?vue&type=style&index=1&id=05b6ac21&lang=css"
script.render = render
script.__scopeId = "data-v-05b6ac21"

export default script